// src/stores/emailStore.ts
import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { type EmailMessage } from '@/types/EmailMessage'
import { EmailModel } from '@/models/EmailModel'

// Extend EmailMessage with BaseEntity fields (id, createdAt, updatedAt)
export interface Email extends EmailMessage {
  id?: string
  createdAt?: Date
  updatedAt?: Date
}

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  to: { value: null, matchMode: FilterMatchMode.CONTAINS },
  from: { value: null, matchMode: FilterMatchMode.CONTAINS },
  'message.subject': { value: null, matchMode: FilterMatchMode.CONTAINS },
  'delivery.state': { value: null, matchMode: FilterMatchMode.EQUALS },
  sentAt: { value: null, matchMode: FilterMatchMode.CONTAINS },
}

export const defaultSort = {
  field: 'sentAt',
  order: -1,
}

// Create the email store using the base document store
export const useEmailStore = defineDocStore<Email>({
  entityName: 'email',
  collection: 'email',
  model: {
    ...EmailModel,
    // Adapt the create method to match the expected signature for ModelHelpers
    create: (data?: Partial<Email>) => EmailModel.create(data || {}),
  },
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})
